import { render, staticRenderFns } from "./recentUpdates.vue?vue&type=template&id=3911de13&scoped=true"
import script from "./recentUpdates.vue?vue&type=script&lang=js"
export * from "./recentUpdates.vue?vue&type=script&lang=js"
import style0 from "./recentUpdates.vue?vue&type=style&index=0&id=3911de13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911de13",
  null
  
)

export default component.exports